// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1IM8E","insightsList":"newBusinessInsightsMenu_insightsList__1THvj","active":"newBusinessInsightsMenu_active__3kkqJ"};